export default function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/FormControl/formControlState.js
// module id = 268
// module chunks = 2